import {EventCustomAction, EventCustomLabel, EventCustomParameters} from '_types'
import {analyticsEventCustom} from './event-custom'

interface Parameters {
    action: EventCustomAction
    label?: EventCustomLabel
    type?: string
    value?: string
}

/**
 * Tracks a menu click event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel} params.label - Label of the event.
 * @param {string} params.type - Menu type of the event.
 * @param {string} params.value - Menu template of the event.
 */
export function analyticsFilters({action, label, type, value}: Parameters) {
    const eventDetails: EventCustomParameters = {
        category: 'filter',
        action: action,
        label: label,
        filterType: type,
        filterValue: value,
    }

    analyticsEventCustom(eventDetails)
}
